export interface AttachmentData {
  name: string
  url?: string
  size?: number
  mime?: string
  width?: number
  height?: number
}

export const formatFileSize = (bytes?: number) =>
  bytes == null
    ? ''
    : bytes >= 1048576
    ? `${(bytes / 1048576).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`
export function safeMediaUrl(value?: string): string | undefined {
  if (!value) return undefined
  try {
    const url = new URL(value, window.location.href)
    return ['https:', 'http:', 'blob:'].includes(url.protocol) ? url.href : undefined
  } catch {
    return undefined
  }
}
export const isImageAttachment = ({ mime, name }: AttachmentData) =>
  /^image\//.test(mime || '') || /\.(png|jpe?g|gif|webp)$/i.test(name)
